import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import Table from "../../table";
import styles from "./CareManagerOverview.module.css";
import Skeleton from "../Skeleton";
import { getCareManagerPerformance } from "../../../services/super-admin-dashboard/careManagerOverview";


const CareManagerOverview = ({ scope = "all", selectedMonthYear }) => {
  const { data: managers = [], isLoading } = useQuery({
    queryKey: ["care-manager-performance", scope, selectedMonthYear],
    queryFn: () => getCareManagerPerformance(scope, selectedMonthYear || undefined),
    staleTime: 5 * 60 * 1000,
  });

  const columns = useMemo(
    () => [
      { key: "care_manager", label: "Care Manager", sorting: true, alignLeft: true },
      { key: "patients", label: "Patients", sorting: true, alignLeft: true },
      { key: "rpm_patients", label: "RPM Patients", sorting: true, alignLeft: true },
      { key: "ccm_patients", label: "CCM Patients", sorting: true, alignLeft: true },
      { key: "rpm_ccm_patients", label: "RPM & CCM Patients", sorting: true, alignLeft: true },
      { key: "calls_made", label: "Calls Made", sorting: true, alignLeft: true },
    
    ],
    []
  );

  if (isLoading) {
    return (
      <div style={{ backgroundColor: "#ffffff", padding: "20px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={`manager-skel-${index}`} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
              <Skeleton width="50%" height="12px" radius="4px" />
              <Skeleton width="50%" height="12px" radius="4px" />
              
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: "#ffffff" }}>
      <Table data={managers} columns={columns} />
    </div>
  );
};

export default CareManagerOverview;
